import styled from "styled-components";
import { Container } from "./Container";
import HeaderBannerImg from "../assets/images/auxiliary_one_llc_banner_white_black.png";

const Hero = styled.section`
  position: relative;
  padding: calc(var(--nav-h) + 64px) 0 var(--section-y);
  overflow: hidden;

  background-image:
    linear-gradient(
      180deg,
      rgba(11, 12, 18, 0.55) 0%,
      rgba(11, 12, 18, 0.82) 55%,
      rgba(11, 12, 18, 0.96) 100%
    ),
    url(${require("../assets/images/pexels-markus-spiske-4383298.jpg")});
  background-size: cover;
  background-position: center;
`;

const HeroInner = styled.div`
  max-width: 880px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 18px;
  align-items: center;
  text-align: center;
`;

const Mark = styled.img`
  width: min(720px, 100%);
  filter: drop-shadow(0 18px 70px rgba(0, 0, 0, 0.55));
`;

const Eyebrow = styled.p`
  text-transform: uppercase;
  letter-spacing: 0.14em;
  font-weight: 750;
  font-size: clamp(12px, 1.35vw, 14px);
  color: rgba(255, 255, 255, 0.72);
`;

const InfoSection = styled.section`
  padding: var(--section-y) 0;
`;

const InfoStack = styled.div`
  max-width: 920px;
  margin: 0 auto;
  display: grid;
  gap: 18px;
`;

const Card = styled.div`
  border: 1px solid var(--border-0);
  background: var(--surface-0);
  border-radius: var(--radius-lg);
  padding: 22px;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.18) inset;
  display: grid;
  gap: 10px;
`;

const CardTitle = styled.h2`
  color: var(--text-0);
  font-size: 22px;
  line-height: 1.15;
  margin-bottom: 10px;
`;

const ToolList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 16px 0 0;
  display: grid;
  gap: 12px;
`;

const ToolItem = styled.li`
  display: grid;
  gap: 6px;
`;

const ToolLabel = styled.span`
  color: var(--text-0);
  font-weight: 800;
  letter-spacing: 0.01em;
`;

const ToolValue = styled.span`
  color: var(--text-1);
`;

export const About = () => {
  return (
    <div>
      <Hero id="about-1">
        <Container>
          <HeroInner>
            <Mark src={HeaderBannerImg} alt="Auxiliary One" />
            <Eyebrow>
              SPECIALIZED & SUPPLEMENTAL SOFTWARE DEVELOPMENT SERVICES
            </Eyebrow>
          </HeroInner>
        </Container>
      </Hero>

      <InfoSection id="about-2">
        <Container>
          <InfoStack>
            <Card>
              <CardTitle>Who we are</CardTitle>
              <p>
                At the helm of our dynamic LLC based in Milford, Connecticut, is
                Nate Paulemon, the owner and director who defines the essence of
                our company. We are a forward-thinking organization specializing
                in the development of web and desktop applications. Our
                commitment is deeply rooted in remaining at the forefront of
                technology trends, a mission led by Nate himself. Through our
                collective expertise, we diligently craft high-quality, custom
                applications that embody our core values of creativity,
                efficiency, and customer-centricity. As a company, we take
                immense pride in our unique ability to seamlessly transform
                ideas into functional, user-friendly software that leaves a
                tangible impact in the ever-evolving digital realm.
              </p>
            </Card>

            <Card>
              <CardTitle>Who we serve</CardTitle>
              <p>
                At our core, we are committed to serving a diverse range of
                clients, including established businesses, individuals, and
                startups who are looking to launch or improve their digital
                presence. We understand that the needs of each client segment
                can vary significantly, and that's why our solutions are
                tailored to meet these specific needs.
              </p>
            </Card>
            <Card>
              <CardTitle>Tools we use</CardTitle>
              <ToolList>
                <ToolItem>
                  <ToolLabel>Programming Languages</ToolLabel>
                  <ToolValue>
                    JavaScript, TypeScript, PHP, Java, Python, SQL
                  </ToolValue>
                </ToolItem>
                <ToolItem>
                  <ToolLabel>Front-End Technologies</ToolLabel>
                  <ToolValue>
                    VueJS, ReactJS, Redux, Mobx, HTML, HTMX, CSS, JQuery
                  </ToolValue>
                </ToolItem>
                <ToolItem>
                  <ToolLabel>Back-End Technologies</ToolLabel>
                  <ToolValue>
                    Apache, ExpressJS, MySQL, MongoDB, AWS, Azure
                  </ToolValue>
                </ToolItem>
                <ToolItem>
                  <ToolLabel>Frameworks</ToolLabel>
                  <ToolValue>
                    MeteorJS, NW.js, ElectronJS, Symfony, Django
                  </ToolValue>
                </ToolItem>
                <ToolItem>
                  <ToolLabel>
                    Continuous Integration / Continuous Delivery
                  </ToolLabel>
                  <ToolValue>
                    Github Actions, Gitlab, Circle, Sentry, Docker
                  </ToolValue>
                </ToolItem>
                <ToolItem>
                  <ToolLabel>AI Tools & LLM Orchestration Frameworks</ToolLabel>
                  <ToolValue>
                    Cursor, Flowise, n8n, Codex, Opik, LangChain
                  </ToolValue>
                </ToolItem>
              </ToolList>
            </Card>
          </InfoStack>
        </Container>
      </InfoSection>
    </div>
  );
};
